import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Label, Modal, Row, Table } from "reactstrap";
import {
  customerType,
  discountTypeOption,
  invoice_type,
  termsOption,
} from "utils/common-options";
import Select from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  calculateCommission,
  calculateEndDateInvoice,
} from "utils/common-helpers";
import Loader from "pages/Separate/Loader";
import { fetchNodeData, FetchNodePutData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import configure from "configure";

const EditZithasInvoice = ({ allOption, closeModal, invoiceData, view }) => {
  const navigate = useNavigate();
  const inputRef = useRef("");
  const [location, setLocation] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [introducer, setIntroducer] = useState([]);
  const [project, setProject] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [terms, setTerms] = useState([]);
  const [dueDate, setDueDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currency, setCurency] = useState([]);
  const [description, setDescription] = useState("");
  const [discountType, setDiscountType] = useState([]);
  const [discountPercent, setDiscountPercent] = useState("");
  const [warnText, setWarnText] = useState("");
  const [convertInrAmount, setConvertInrAmount] = useState("");
  const [customerOption, setCustomerOption] = useState([]);
  const [curencyOption, setCurrencyOption] = useState([]);
  const [projectOption, setProjectOption] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [addCommision, setAddCommission] = useState(false);
  const [commType, setCommType] = useState([]);
  const [commission, setCommission] = useState("");
  const [formId, setFormId] = useState("");
  const [serviceOption, setServiceOption] = useState([]);
  const [invId, setInvId] = useState("");
  const [tabType, setTabType] = useState([]);
  const [tempCustOption, setTemCustOption] = useState([]);
  const [formRows, setFormRows] = useState([
    {
      id: 1,
      service_details: "",
      hsn: "",
      quantity: "1",
      rate: "",
      amount: "",
      service: "",
      project: "",
      comm: "0",
      commission_type: "",
      commission_raw: "0",
    },
  ]);

  const [hsnOptions, setHsnOptions] = useState([]);

  useEffect(() => {
    const fetchHSN = async () => {
      try {
        const response = await fetchNodeData(
          setLoading,
          "hsn",
          secureLocalStorage.getItem("auth_token"),
        );
        if (response.success) {
          // Map the API data to a format React-Select understands
          const options = response.data?.map((item) => ({
            label: `${item.number} - ${item.title}`, // Shows "2396 - Sukuna" in dropdown
            value: String(item.number), // This stores the HSN number as the value
            string: item.title,
          }));
          setHsnOptions(options);
        }
      } catch (error) {
        console.error("Error fetching HSN data:", error);
      }
    };

    fetchHSN();
  }, []);

  useEffect(() => {
    const selectOptions = (data, label, value) => {
      return data?.map((obj) => ({
        label: obj[label],
        value: obj[value],
        ...obj,
      }));
    };
    setInvId(invoiceData?.id);
    setIncludeInReminder(Number(invoiceData?.include_in_reminder) !== 0);
    setLocation(
      getLocations?.find((opt) => opt?.value == invoiceData?.location),
    );
    setInvoiceType(
      invoice_type?.find((opt) => opt?.value == invoiceData?.invoice_type_name),
    );
    const customerId = selectOptions(
      allOption?.customer,
      "company",
      "id",
    )?.find((opt) => opt?.value == invoiceData?.customer_id);
    const tempOptions = customerType?.find(
      (obj) => obj?.value == invoiceData?.customer_type,
    );
    const tempOption = allOption?.tempCustomer?.map((obj) => ({
      label: obj?.company,
      value: obj?.id,
      ...obj,
    }));
    const tempCust = tempOption?.find(
      (obj) => obj?.value == invoiceData?.customer_id,
    );
    setTemCustOption(tempOption);
    setCustomer(invoiceData?.customer_type == 1 ? customerId : tempCust);
    setTabType(tempOptions);
    setInvoiceNumber(invoiceData?.invoice_number);
    setInvoiceDate(moment(invoiceData?.invoice_date).format("YYYY-MM-DD"));
    setStartDate(moment(invoiceData?.start_date).format("YYYY-MM-DD"));
    setEndDate(moment(invoiceData?.end_date).format("YYYY-MM-DD"));
    setTerms(termsOption?.find((opt) => opt?.value == invoiceData?.terms));
    setDueDate(moment(invoiceData?.due_date).format("YYYY-MM-DD"));
    setDescription(invoiceData?.customer_note);
    setCurency(
      selectOptions(allOption?.currency, "currency", "id")?.find(
        (opt) => opt?.value == invoiceData?.c_currency,
      ),
    );
    setIntroducer(
      invoiceData?.customer_type == 1
        ? {
            value: customerId?.source_name,
            label: customerId?.introducer_name,
          }
        : { value: tempCust?.source_name, label: tempCust?.introducer_name },
    );
    setFormRows(
      invoiceData?.items?.map((opt, i) => {
        const projectOption =
          selectOptions(allOption?.project, "project_name", "id")?.find(
            (obj) => obj?.value == opt?.project_id,
          ) ||
          (opt?.project_id
            ? { label: opt.project_id, value: opt.project_id }
            : null);
        const commissionRaw = opt?.commission_raw ?? null;
        const commissionAmount =
          commissionRaw != null
            ? opt?.commission_amount
            : calculateCommission(projectOption, opt.rate, opt.quantity);
        const commissionType =
          opt?.commission_type ??
          (projectOption?.commission_structure?.toLowerCase() || null);
        let actaulCommisiion = 0;
        if (opt?.commission_type?.toLowerCase() == "percentage") {
          actaulCommisiion =
            (Number(opt?.commission_amount) / Number(opt?.amount)) * 100;
        } else {
          actaulCommisiion = opt?.commission_amount;
        }
        const mainCommission =
          commissionRaw != null
            ? actaulCommisiion
            : calculateCommission(projectOption, opt.rate, opt.quantity);

        return {
          id: i + 1,
          service_details: opt?.service_detail,
          hsn: hsnOptions?.find((obj) => obj?.value == opt?.hsn),
          quantity: opt?.quantity,
          rate: opt?.rate,
          amount: opt?.amount,
          service: selectOptions(allOption?.service, "service", "id")?.find(
            (obj) => obj?.label == opt?.service,
          ),
          project: projectOption,
          comm: commissionAmount,
          commission_raw: mainCommission,
          // commission_raw:
          //   commissionRaw ??
          //   (projectOption?.commission
          //     ? projectOption.commission.toString()
          //     : ""),
          commission_type: commissionType,
        };
      }),
    );
    setDiscountType(
      discountTypeOption?.find(
        (obj) => obj?.value == invoiceData?.discount_type,
      ),
    );
    setDiscountPercent(invoiceData?.discount_type_amount);
    setCurrencyOption(selectOptions(allOption?.currency, "currency", "id"));
    setCustomerOption(selectOptions(allOption?.customer, "company", "id"));
    setProjectOption(selectOptions(allOption?.project, "project_name", "id"));
    setServiceOption(selectOptions(allOption?.service, "service", "id"));
  }, [allOption, invoiceData, hsnOptions]);

  useEffect(() => {
    setDueDate(calculateEndDateInvoice(invoiceDate, Number(terms?.day)));
  }, [invoiceDate, terms]);

  let getLocations = useSelector((state) => state?.location?.locations);

  getLocations = useMemo(
    () => getLocations.filter((l) => configure.location.includes(l.value)),
    [],
  );

  const totalAmount = formRows.reduce(
    (sum, row) => sum + (row.rate * row.quantity || 0),
    0,
  );
  const subtotal = formRows.reduce(
    (sum, row) => sum + (row.rate * row.quantity || 0),
    0,
  );
  const [includeInReminder, setIncludeInReminder] = useState(true);
  const [discountAmount, setDiscountAmount] = useState("0");
  useEffect(() => {
    if (discountType?.value?.toLowerCase() == "percentage") {
      setDiscountAmount((subtotal / 100) * discountPercent);
    } else {
      setDiscountAmount(discountPercent);
    }
  }, [discountPercent, discountType]);
  const total = subtotal - discountAmount;
  const deleteFormRow = (id) => {
    setFormRows(formRows.filter((row) => row.id !== id)); // Remove the row with the given ID
  };
  const addFormRow = () => {
    const modifiedRows = [...formRows];
    setFormRows([
      ...formRows,
      {
        id: modifiedRows.length + 1,
        service_details: "",
        hsn: "",
        quantity: "1",
        rate: "",
        amount: "",
        service: "",
        project: "",
        comm: "0",
        commission_type: "",
      },
    ]);
  };
  const onInputChange = (id, field, value) => {
    setFormRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === id) {
          const updatedRow = { ...row, [field]: value };
          if (field === "quantity" || field === "rate") {
            const quantity = parseFloat(updatedRow.quantity) || 0;
            const rate = parseFloat(updatedRow.rate) || 0;
            updatedRow.amount = (quantity * rate).toFixed(2);
          }

          return updatedRow;
        }
        return row;
      }),
    );
  };

  useEffect(() => {
    if (invoiceDate && currency?.length != 0) {
      setWarnText("");
      setConvertInrAmount("");
      if (currency?.label !== "INR") {
        const fetchCurrencyRate = async () => {
          setLoading(true);
          try {
            const apiDate = moment(invoiceDate).isAfter(moment(), "day")
              ? moment().format("YYYY-MM-DD")
              : invoiceDate
            const response = await axios.get(
              `https://api.frankfurter.dev/v1/${apiDate}?from=${currency?.label}&to=INR`
            );
            setLoading(false);
            const rate = response.data.rates.INR;
            const { value } = await Swal.fire({
              title: "Exchange Rate Fetched",
              html: `<b>1 ${currency?.label} = ${rate.toFixed(2)} INR</b><br/><small>Confirm or enter a different rate.</small>`,
              input: "text",
              inputValue: rate.toFixed(2),
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonText: "Confirm",
              inputValidator: val => {
                if (!val || isNaN(val) || Number(val) <= 0) return "Please enter a valid exchange rate."
              },
            });
            if (value) {
              setConvertInrAmount(value.replace(/[^0-9.]/g, ""));
              setWarnText(`Exchange Rate of ${currency?.label} is ${value}`);
            }
          } catch (error) {
            setLoading(false);
            console.error("Error fetching currency rate:", error);
            const { value } = await Swal.fire({
              title: "Exchange Rate Not Available",
              text: `Could not fetch rate for ${currency?.label}. Please enter it manually.`,
              input: "text",
              inputPlaceholder: `1 ${currency?.label} = ? INR`,
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonText: "Set Rate",
              inputValidator: val => {
                if (!val || isNaN(val) || Number(val) <= 0) return "Please enter a valid exchange rate."
              },
            })
            if (value) setConvertInrAmount(value.replace(/[^0-9.]/g, ""))
          }
        };
        fetchCurrencyRate();
        // setIsConvertedAmount(true)
      } else {
        // setIsConvertedAmount(false)
      }
    } else if (invoiceDate && currency == null) {
      setWarnText("Please Select currency");
    } else if (invoiceDate == null && currency) {
      setWarnText("Please Select Invoice Date");
    } else {
      setWarnText("");
    }
  }, [invoiceDate, currency]);

  const onAddCommission = (e) => {
    e.preventDefault();
    const array = formRows?.find((obj) => obj?.id == formId);
    const amount = Number(array?.rate) * Number(array?.quantity);
    let commissionAmount;
    if (commType?.value?.toLowerCase() == "percentage") {
      commissionAmount = (commission / 100) * amount;
    } else {
      commissionAmount = commission;
    }
    setFormRows(
      formRows?.map((obj) =>
        obj.id == formId
          ? {
              ...obj,
              comm: commissionAmount,
              commission_type: commType?.value,
              commission_raw: commission,
            }
          : obj,
      ),
    );
    setAddCommission(false);
  };
  const token = secureLocalStorage.getItem("auth_token");

  const onAddInvoice = async (e) => {
    e.preventDefault();
    if (currency?.value && currency?.label !== "INR" && !convertInrAmount) {
      Swal.fire({ icon: "warning", text: "Please enter the exchange rate for the selected currency." })
      return
    }
    const items = formRows?.map((obj) => ({
      ...obj,
      hsn: obj?.hsn?.value,
      project: obj?.project?.value,
      service: obj?.service?.label,
    }));
    const formEntries = {
      location: location?.value,
      invoice_type: invoiceType?.value,
      customer_id: customer?.value,
      introducer_id: introducer?.value,
      invoice_no: invoiceNumber,
      invoice_date: invoiceDate,
      terms: terms?.value,
      due_date: dueDate,
      start_date: moment(startDate)?.isValid() ? startDate : null,
      end_date: moment(endDate)?.isValid() ? endDate : null,
      currency: currency?.value,
      customer_note: description,
      discount_type: discountType?.value,
      discount_type_amount: discountPercent,
      discount_amount: discountAmount,
      total_amount: total,
      amount: subtotal,
      exchange_rate: convertInrAmount,
      items: items,
      user_id: localStorage.getItem("auth_id"),
      customer_type: tabType?.value,
      include_in_reminder: includeInReminder ? 1 : 0,
    };
    const res = await FetchNodePutData(
      setLoading,
      `zithasInvoice`,
      invId,
      formEntries,
    );
    if (res?.status == 200) {
      Swal.fire({
        icon: "success",
        text: "Invoice Edited Successfully",
        showConfirmButton: true,
      });
      closeModal(false, true);
      setLocation([]);
      setInvoiceType([]);
      setCustomer([]);
      setIntroducer([]);
      setProject([]);
      setInvoiceNumber("");
      setInvoiceDate("");
      setTerms([]);
      setDueDate("");
      setStartDate("");
      setEndDate("");
      setCurency([]);
      setDescription("");
      setDiscountType([]);
      setDiscountPercent("");
      setWarnText("");
      setConvertInrAmount("");
      setCustomerOption([]);
      setCurrencyOption([]);
      setProjectOption([]);
      setLoading(false);
      setAddCommission(false);
      setCommType([]);
      setCommission("");
      setFormId("");
      setServiceOption([]);
    }
  };

  useEffect(() => {
    if (formId) {
      const row = formRows.find((obj) => obj.id === formId);
      if (row) {
        const matchedOption = discountTypeOption.find(
          (option) =>
            option.value.toLowerCase() ===
            (row.commission_type || "").toLowerCase(),
        );
        setCommType(matchedOption || null);
        setCommission(row.commission_raw || ""); // Use raw commission here, NOT calculated
      }
    }
  }, [formId, formRows]);

  return (
    <>
      {isLoading && <Loader />}
      <div className="modal-header mb-0">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ width: "100%" }}
        >
          <div className="col-6 d-flex align-items-center">
            <h5 className=" modal-title mt-0">Edit Invoice</h5>
          </div>
        </div>

        <div className="d-flex gap-3 align-items-center">
          {!view ? (
            <button
              className=" btn ms-md-2 btn-save btn-label"
              onClick={onAddInvoice}
            >
              <i className="fas fa-save me-1 label-icon"></i> save
            </button>
          ) : null}
          <a
            onClick={(e) => {
              closeModal(false);
            }}
            className=" btn ms-md-2 btn-red btn-label"
          >
            <i className="dripicons-cross me-2 icon-center label-icon"></i>
            CANCEL
          </a>
        </div>
      </div>

      <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
        <div className="mb-3" style={{ padding: "0 11px 0 12px" }}>
          <Row className="bg-white px-2 py-4 shadow mb-3">
            <div className="col-md-2 mb-3">
              <label htmlFor="">Location</label>
              <Select
                placeholder="Select"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={getLocations}
                value={location}
                onChange={(e) => setLocation(e)}
                isDisabled={view}
              />
            </div>
            <div className="col-md-2 mb-3 mb-md-0">
              <label htmlFor="">
                Invoice Type <span className="text-danger">*</span>
              </label>
              <Select
                placeholder="Select Type"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={invoice_type}
                value={invoiceType}
                onChange={(e) => setInvoiceType(e)}
                isDisabled={view}
              />
            </div>
            <div className="col-md-2 mb-3 mb-md-0">
              <label htmlFor="">
                Customer Type <span className="text-danger">*</span>
              </label>
              <Select
                placeholder="Select Type"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={customerType}
                value={tabType}
                onChange={(e) => setTabType(e)}
              />
            </div>
            <div className="col-md-3 mb-3 mb-md-0">
              <label htmlFor="">
                Customer Name <span className="text-danger">*</span>
              </label>
              <Select
                name="country"
                placeholder="Select Customer Name"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={
                  tabType?.value == 2
                    ? tempCustOption
                    : tabType?.value == 1
                    ? customerOption
                    : []
                }
                value={customer}
                isDisabled={view}
                onChange={(e) => {
                  setCustomer(e);
                  if (e?.introducer_name != undefined) {
                    setIntroducer({
                      value: e?.source_name,
                      label: e?.introducer_name,
                    });
                  } else {
                    setIntroducer([]);
                  }
                }}
              />
            </div>
            {introducer?.length != 0 ? (
              <div className="col-md-2 mb-3 mb-md-0">
                <label htmlFor="">Introducer</label>
                <Select
                  name="project"
                  isDisabled
                  placeholder="Select Introducer"
                  className="basic-multi-select"
                  classNamePrefix=" select"
                  value={introducer}
                  onChange={(e) => setIntroducer(e)}
                />
              </div>
            ) : null}
            {!view ? (
              <div className="col-md-2 mb-3 mb-md-0">
                <label htmlFor="">Payment Reminder</label>
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ cursor: "pointer", height: "38px" }}
                  onClick={() => setIncludeInReminder(!includeInReminder)}
                  title={includeInReminder ? "Included in payment reminder" : "Excluded from payment reminder"}
                >
                  <div
                    style={{
                      width: 52,
                      height: 28,
                      borderRadius: 999,
                      background: includeInReminder ? "#762b98" : "#ccc",
                      position: "relative",
                      transition: "background 0.2s ease",
                      flexShrink: 0,
                    }}
                  >
                    <div
                      style={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: "#fff",
                        position: "absolute",
                        top: 3,
                        left: includeInReminder ? 27 : 3,
                        transition: "left 0.2s ease",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </Row>
          <Row className="bg-white px-2 py-4 shadow mb-3">
            <div className="col-md-3 mb-3">
              <label htmlFor="">
                Invoice Number <span className="text-danger">*</span>{" "}
              </label>
              <input
                required
                type="text"
                name="invoice_number"
                placeholder="Enter Invoice Number"
                className="form-control "
                disabled={view}
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="">
                Invoice Date <span className="text-danger">*</span>{" "}
              </label>
              <input
                required
                type="date"
                name="invoice_date"
                placeholder="Select Invoice Date"
                className="form-control "
                disabled={view}
                value={invoiceDate}
                onChange={(e) => setInvoiceDate(e.target.value)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="">
                Terms <span className="text-danger">*</span>{" "}
              </label>
              <Select
                placeholder="Select Term"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={termsOption}
                value={terms}
                isDisabled={view}
                onChange={(e) => setTerms(e)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="">
                Due Date <span className="text-danger">*</span>{" "}
              </label>
              <input
                type="date"
                name="due_date"
                placeholder="Select Due Date"
                className="form-control"
                value={dueDate}
                disabled
                onChange={(e) => setDueDate(e.target.value)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="">Start Date</label>
              <input
                type="date"
                name="start_date"
                placeholder="Select Start Date"
                className="form-control"
                value={startDate}
                disabled={view}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="">End Date</label>
              <input
                type="date"
                name="end_date"
                placeholder="Select End Date"
                className="form-control"
                value={endDate}
                disabled={view}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="">Currency</label>
              <Select
                placeholder="Select Currency"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={curencyOption}
                value={currency}
                isDisabled={view}
                onChange={(e) => setCurency(e)}
              />
            </div>
            <div className="col-md-3 d-flex justify-content-center">
              {warnText ? (
                <h5>{warnText}</h5>
              ) : currency?.label && currency.label !== "INR" && !isLoading && invoiceDate ? (
                <div className="w-100">
                  <label>Exchange Rate (1 {currency.label} = ? INR) <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter exchange rate"
                    value={convertInrAmount}
                    onChange={e => setConvertInrAmount(e.target.value.replace(/[^0-9.]/g, ""))}
                  />
                </div>
              ) : null}
            </div>
          </Row>

          {/* Service Details  */}
          <Row className="bg-white px-2 py-4 shadow mb-3">
            <div className="d-flex justify-content-between">
              <h5> Service Details</h5>
              <div className="text-end mb-3">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    addFormRow();
                  }}
                  className="btn btn-purple  "
                  disabled={view}
                >
                  <i className="fas fa-plus me-2"></i>
                  Add More
                </button>
              </div>
            </div>

            <div className="mb-2">
              <div className="d-flex flex-column">
                <Table bordered hover striped>
                  <thead>
                    <tr>
                      <th className="service-col-2">SERVICE DETAILS</th>
                      <th className="hsn-col-3 text-center">HSN</th>
                      <th className="qty-col-4 text-center">QTY</th>
                      <th className="text-center rate-col-5">RATE</th>
                      {introducer?.length != 0 ? (
                        <th className="text-center qty-col-4">COMM.</th>
                      ) : null}
                      <th className="text-center amt-col-5">AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formRows.map((row, key) => {
                      return (
                        <tr key={row.id}>
                          <td className="service-col-2">
                            <div className="row mb-2">
                              <Select
                                name="service"
                                placeholder="Select Service"
                                className="basic-multi-select col-md-4"
                                classNamePrefix="select"
                                options={serviceOption}
                                isDisabled={view}
                                value={row.service}
                                onChange={(selectedOption) =>
                                  onInputChange(
                                    row.id,
                                    "service",
                                    selectedOption,
                                  )
                                }
                              />
                              <CreatableSelect
                                isClearable
                                name="project"
                                placeholder="Select Project"
                                className="basic-multi-select col-md-8"
                                classNamePrefix=" select"
                                isDisabled={view}
                                onInputChange={(newValue, { action }) => {
                                  if (action === "input-change") {
                                    inputRef.current = newValue;
                                  }
                                }}
                                options={projectOption?.filter(
                                  (opt) =>
                                    // opt?.customer == customer?.value &&
                                    opt?.service == row?.service?.label,
                                )}
                                value={row.project}
                                onChange={(selectedOption) => {
                                  const commissionAmount = calculateCommission(
                                    selectedOption,
                                    row.rate,
                                    row.quantity,
                                  );

                                  onInputChange(
                                    row.id,
                                    "project",
                                    selectedOption,
                                  );
                                  onInputChange(
                                    row.id,
                                    "commission_raw",
                                    selectedOption?.commission?.toString() ||
                                      "",
                                  );
                                  onInputChange(
                                    row.id,
                                    "comm",
                                    commissionAmount,
                                  );
                                  onInputChange(
                                    row.id,
                                    "commission_type",
                                    selectedOption?.commission_structure || "",
                                  );
                                }}
                                onBlur={() => {
                                  const typed = inputRef.current.trim();
                                  if (
                                    typed &&
                                    (!row.project ||
                                      row.project.value !== typed)
                                  ) {
                                    const newOption = {
                                      label: typed,
                                      value: typed,
                                    };
                                    onInputChange(row.id, "project", newOption);
                                  }
                                  inputRef.current = "";
                                }}
                              />
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Description"
                              value={row.service_details}
                              disabled={view}
                              onChange={(e) =>
                                onInputChange(
                                  row.id,
                                  "service_details",
                                  e.target.value,
                                )
                              }
                            />
                          </td>
                          <td className="hsn-col-3">
                            <Select
                              name="hsn"
                              placeholder="Select"
                              className="basic-multi-select hsn-width"
                              classNamePrefix="select"
                              options={hsnOptions}
                              isDisabled={view}
                              value={row.hsn}
                              onChange={(selectedOption) =>
                                onInputChange(row.id, "hsn", selectedOption)
                              }
                            />
                          </td>
                          <td className="qty-col-4 text-center">
                            <input
                              type="text"
                              className="form-control text-center"
                              value={row.quantity}
                              disabled={view}
                              onChange={(e) => {
                                const newQuantity = e.target.value;
                                setFormRows(
                                  formRows.map((obj) => {
                                    if (obj.id === row.id) {
                                      const commissionAmount =
                                        calculateCommission(
                                          obj.project,
                                          obj.rate,
                                          newQuantity,
                                        );
                                      return {
                                        ...obj,
                                        quantity: newQuantity,
                                        comm: commissionAmount,
                                      };
                                    }
                                    return obj;
                                  }),
                                );

                                onInputChange(row.id, "quantity", newQuantity);
                              }}
                            />
                          </td>
                          <td className="text-center rate-col-5">
                            <input
                              type="text"
                              className="form-control"
                              value={row.rate}
                              disabled={view}
                              onChange={(e) => {
                                const newRate = e.target.value;
                                setFormRows(
                                  formRows.map((obj) => {
                                    if (obj.id === row.id) {
                                      const commissionAmount =
                                        calculateCommission(
                                          obj.project,
                                          newRate,
                                          obj.quantity,
                                        );
                                      return {
                                        ...obj,
                                        rate: newRate,
                                        comm: commissionAmount,
                                      };
                                    }
                                    return obj;
                                  }),
                                );
                                onInputChange(row.id, "rate", newRate);
                              }}
                            />
                          </td>
                          {introducer?.length != 0 ? (
                            <td className="text-center rate-col-5">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={row.comm}
                                  disabled={view}
                                  onChange={(e) =>
                                    onInputChange(
                                      row.id,
                                      "comm",
                                      e.target.value,
                                    )
                                  }
                                />
                                <a
                                  title="edit"
                                  className="cancel-row"
                                  onClick={() => {
                                    if (row.rate != "") {
                                      setAddCommission(true);
                                      setCommType(
                                        discountTypeOption?.find(
                                          (obj) =>
                                            obj?.value?.toLocaleLowerCase() ==
                                            row?.commission_type?.toLocaleLowerCase(),
                                        ),
                                      );
                                      setCommission(row?.commission_raw);
                                      setFormId(row?.id);
                                    } else {
                                      swal({
                                        text: "Please Enter Rate before adding Commission",
                                        icon: "warning",
                                        buttons: true,
                                        dangerMode: true,
                                      });
                                    }
                                  }}
                                >
                                  <i className="fas fa-pen font-size-10"></i>
                                </a>
                              </div>
                            </td>
                          ) : null}
                          <td className="text-center amt-col-5 position-relative">
                            <h5>{row.rate * row.quantity}</h5>
                            {key > 0 && (
                              <a
                                title="delete"
                                className="cancel-row"
                                onClick={() => deleteFormRow(row.id)}
                              >
                                <i className="fas fa-times font-size-10"></i>
                              </a>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </Row>

          {/* Customer Notes  */}
          <Row className="bg-white px-2 py-4 shadow mb-3">
            <div className="col-7 edit-descrip" id="ckeEditor">
              <div className="d-flex justify-space-between">
                <label htmlFor="">
                  Customer Notes <span className="text-danger">*</span>
                </label>
                <span
                  className="text-danger"
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    paddingTop: "7px",
                  }}
                ></span>
              </div>
              <CKEditor
                editor={ClassicEditor}
                className="ckeEditor"
                disabled={view}
                data={
                  description
                    ? description
                    : "Thank you for giving us an opportunity! Hoping work from you in future "
                }
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setDescription(data);
                }}
              />
            </div>
            <div className="col-5 checkout-box py-5 px-5">
              <div className="col-12 mb-3 d-flex justify-space-between">
                <h5>Sub Total</h5>
                <h5>{totalAmount.toFixed(2)}</h5>
              </div>
              <div className="col-12 mb-3 d-flex justify-space-between">
                <div className="col-6 d-flex gap-3">
                  <div className="d-flex flex-column col-md-8">
                    <label htmlFor="">Select Discount</label>
                    <Select
                      name="select discount"
                      placeholder="Select"
                      className="basic-multi-select "
                      classNamePrefix=" select"
                      options={discountTypeOption}
                      value={discountType}
                      isDisabled={view}
                      onChange={(e) => {
                        setDiscountPercent("");
                        setDiscountType(e);
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <label></label>
                    <input
                      type="text"
                      name="discount"
                      className="form-control text-center mt-2"
                      value={discountPercent}
                      disabled={view}
                      onChange={(e) => setDiscountPercent(e.target.value)}
                    />
                  </div>
                </div>
                <h5>{Number(discountAmount).toFixed(2)}</h5>
              </div>
              <div className="tax-box">
                <div className="col-12 mb-3 d-flex justify-content-end gap-3">
                  <h5>Total ( {currency?.symbol} )</h5>
                  <h5>{total.toFixed(2)}</h5>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </div>

      <Modal
        isOpen={addCommision}
        size="sm"
        className="bd-custom-md-3"
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Introducer Commission</h5>
          <button
            type="button"
            onClick={() => {
              setAddCommission(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form className="row" onSubmit={onAddCommission}>
            <div className="col-md-7">
              <label htmlFor="">Select Commission Type</label>
              <Select
                name="select discount"
                placeholder="Select"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={discountTypeOption}
                value={commType}
                onChange={(e) => {
                  setCommission("");
                  setCommType(e);
                }}
              />
            </div>
            <div className="mb-3 col-md-5">
              <Label htmlFor="formrow-firstname-Input">Commission</Label>
              <input
                type="text"
                className="form-control"
                id="formrow-firstname-Input"
                placeholder="Commission"
                value={commission}
                onChange={(e) => setCommission(e.target.value)}
                required
              />
            </div>
            <div className="mt-20">
              <button type="submit" className="border-radius btn btn-purple">
                Add Commission
              </button>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default EditZithasInvoice;
